import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";
import EventForm, { eventToForm } from "@/components/EventForm";
import EventStatusActions from "@/components/EventStatusActions";
import StatusBadge from "@/components/StatusBadge";

export default function EditEvent({ admin = false }) {
  const { event_id } = useParams();
  const { user, t, checkingAuth } = useApp();
  const nav = useNavigate();
  const [ev, setEv] = useState(null);
  useEffect(() => { if (user) api.get(`/events/by-id/${event_id}`).then(r => setEv(r.data)).catch(() => setEv(false)); }, [event_id, user]);
  if (checkingAuth) return null;
  if (!user) return <Navigate to="/auth" />;
  if (admin && user.role !== "admin") return <div className="p-8">403 — Admin only.</div>;
  if (ev === false) return <div className="p-8 eyebrow">{t("notFound")}</div>;
  if (!ev) return null;
  const submit = async (payload) => {
    await api.put(`/events/${event_id}`, payload);
    toast.success(t("savedEvent"));
    nav(admin ? `/admin/events/${event_id}` : "/dashboard");
  };
  const initial = eventToForm(ev.pending_changes ? { ...ev, ...ev.pending_changes } : ev);
  return (
    <div className="max-w-4xl mx-auto px-4 md:px-6 py-8" data-testid="edit-event-page">
      <div className="eyebrow text-primary">{admin ? t("admin") : t("dashboard")}</div>
      <h1 className="font-display uppercase text-4xl md:text-5xl tracking-tighter border-b border-foreground pb-3">{t("editEvent")}</h1>
      {(ev.mod_status === "changes_requested" || ev.mod_status === "rejected") && ev.mod_comment && (
        <div className="mt-6 p-4 border border-primary" data-testid="edit-mod-comment"><div className="eyebrow">{t("adminFeedback")}</div><p className="mt-1 text-sm">{ev.mod_comment}</p></div>
      )}
      {ev.mod_status === "pending" && <div className="mt-6 p-3 border border-foreground text-sm" data-testid="edit-pending-note"><StatusBadge status="pending" /> <span className="ml-2">{t("preview")}: <a className="underline" href={`/events/${ev.slug}`}>{ev.slug}</a></span></div>}
      <EventForm initial={initial} onSubmit={submit} excludeId={event_id}
        submitLabel={admin ? t("saveEvent") : ev.mod_status === "changes_requested" || ev.mod_status === "rejected" ? t("resubmit") : t("saveChanges")} />
      {(user?.user_id === ev.organizer_id || ev.me_manages || (user?.role === "admin" && ev.editorial)) && <EventStatusActions event={ev} variant="panel" onUpdated={d => setEv(x => ({ ...x, ...d }))} />}
    </div>
  );
}
